/**
 * Per-tab storage for a verified Shared Startup Profile view session
 * (MYN-58). Deliberately separate from `lib/auth/session.ts` (the platform's
 * own login session) - this token is scoped to one share link, lives only
 * for the tab (sessionStorage, not localStorage), and is never attached to
 * the platform's authenticated API client.
 */
const keyFor = (token: string) => `mnr.shareAccessToken.${token}`;

export function getShareAccessToken(token: string): string | null {
  try {
    return sessionStorage.getItem(keyFor(token));
  } catch {
    return null;
  }
}

export function setShareAccessToken(token: string, accessToken: string): void {
  try {
    sessionStorage.setItem(keyFor(token), accessToken);
  } catch {
    // storage unavailable (private mode / quota) - session stays in-memory only
  }
}

export function clearShareAccessToken(token: string): void {
  try {
    sessionStorage.removeItem(keyFor(token));
  } catch {
    // no-op
  }
}
